import React from 'react';
import { Switch } from '@rsos/base-components';
import { SwitchContainer, SwitchLabel } from './Modal.styles';

type ModalSwitchProps = {
  label: string;
  isOn: boolean;
  dataName: string;
  onClick: () => void;
};

const ModalSwitch: React.FC<ModalSwitchProps> = ({
  label,
  isOn,
  dataName,
  onClick,
}) => {
  return (
    <SwitchContainer data-name={dataName}>
      <SwitchLabel>{label}</SwitchLabel>
      <Switch
        isOn={isOn}
        onClick={onClick}
        wrapperHeight="18px"
        wrapperWidth="30px"
        toggleBottom="3px"
        toggleHeight="12px"
        toggleWidth="12px"
      />
    </SwitchContainer>
  );
};
export default ModalSwitch;
